exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".signaturepad{\n  padding: 5px;\n}\n.button-wrapper{\n  margin-top: 10px;\n}\n\n.sigCanvas{\n  border: 1px solid gray;\n  border-radius: 5px;\n}\n@media (min-width:320px) and (max-width:560px){\n  .sigCanvas{\n    width: 100%;\n  }\n}", ""]);

